import React from 'react'

const CheckOut = () => {
    return (
        <div>
            <p className="text-2xl text-center font-semibold py-20">
                Your Checkout process is underway. Please Wait.....
            </p>
        </div>
    )
}

export default CheckOut
